import React, { createContext, useContext, useState } from 'react';

// Create context for ticket data
const TicketContext = createContext();

// Custom hook to use the ticket context
export const useTicketData = () => {
    const context = useContext(TicketContext);
    if (!context) {
        return { ticketData: [], publicHolidays: [] }; // Return empty arrays if not in context
    }
    return context;
};

// Provider component
export const TicketDataProvider = ({ children }) => {
    const [ticketData, setTicketData] = useState([]);
    const [publicHolidays, setPublicHolidays] = useState([]);

    return (
        <TicketContext.Provider value={{ ticketData, setTicketData, publicHolidays, setPublicHolidays }}>
            {children}
        </TicketContext.Provider>
    );
};
